import { sizeChartConstants } from "../../constants";
import { sizeChartService } from "../../services";
import { alertActions } from "../alert.actions";

export const sizeChartActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    sizeChartService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: sizeChartConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: sizeChartConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: sizeChartConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code) {
  return (dispatch) => {
    dispatch(request(name, code));

    sizeChartService.addParameter(name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: sizeChartConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: sizeChartConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: sizeChartConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code) {
  return (dispatch) => {
    dispatch(request(id, name, code));

    sizeChartService.updateParameter(id, name, code).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: sizeChartConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: sizeChartConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: sizeChartConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    sizeChartService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: sizeChartConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: sizeChartConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: sizeChartConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: sizeChartConstants.CLEAR };
}
